import React from "react";
import Project from "./projetEtp";

export function ProjectInPreparation() {
  return <Project status="En préparation" />;
}